import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ec3bkdsy: FaireBrandEntity = {
  token: "b_ec3bkdsy",
  type: "brand",
  name: "8 Oak Lane",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/6b1b790df5ac2915993bdd5938ebbca5b0613605aff3c709223cfbf842ea88e3/1539874951.jpg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8af2949c879618b90fe17f41f867618da7b76b8b7b69bceb39046be6138c33ed.jpeg",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/6b1b790df5ac2915993bdd5938ebbca5b0613605aff3c709223cfbf842ea88e3/1539874951.jpg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8af2949c879618b90fe17f41f867618da7b76b8b7b69bceb39046be6138c33ed.jpeg",
  location: "Indianapolis , IN, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 671,
  isTopShop: true,
  isInsider: true,
  description:
    "Inspired by all things current, clever and creative. Tabletop, Apparel, Home Fragrance and Gifts that satisfy the inner creative in everyone. It's life at 8 Oak Lane... We're glad you're here!\n\nIf you have any questions at all, please email [redacted-email] or call ([redacted-phone] for assistance. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:43.848Z",
    importedBy: "entity-db-cli",
  },
};
